export default "__VITE_ASSET__BKaawJzv__"